/**
 * settingParam 参数的说明和取的位置：
 * 左侧包括标题 "待添加"和搜索框帮助快速定位
 */
import React, { Component, Fragment } from 'react';
import Button from '../Button';
import Tooltip from '../Tooltip';
import SideBox from '../Sidebox';
import HotKeys from '../HotKeys';
import TabsControl from '../-TabsControl';
import SettingSideBoxContent from './SettingSideBoxContent';
import OtherSettings from './OtherSettings';
import { toast, getMultiLang, isUndefined } from '@platform/api';
import './settingSideBox.less';

export const SettingSideBoxContext = React.createContext();

export default class SettingSideBox extends Component {
    constructor(props) {
        super(props);
        // let isEllipsis = !props?.tableScope?.state?.isEllipsis;
        // let tableHeight = props?.tableScope?.state?.tableHeight;
        this.state = {
            // displayData: props.leftData, //左侧待选列显示模板
            // sortData: newSortData, //被选择排序的列显示模板
            tabList: this.getNewTabList(props.tabList),
            tabActiveIndex: props.tabActiveIndex,
            json: {}, // 多语
            // isEllipsis: isEllipsis, // 自动换行
            // saveWidthFlag: false, // 保存列宽
            // resetWidthFlag: false, // 重置列宽
            // tableHeight: tableHeight, // 表格高度
            // showSubTotalFlag: false, // 显示小计
        };
    }

    UNSAFE_componentWillMount() {
        let callback = (json, bool) => {
            if (bool) {
                this.setState({ json }, () => {
                });
            }
        };
        getMultiLang({ moduleId: 'base_table', callback });
    }

    // 更新一下props.sortData
    getNewTabList = data => {
        for (let index = 0; index < data.length; index++) {
            const element = data[index];
            let sortData = element.sortData;
            if (sortData) {
                let filterData = sortData.filter(item => item.islock);
                let lockCol = filterData.length;
                if (lockCol > 0) {
                    sortData[lockCol - 1].isLastLockCol = true;
                }
            }
        }
        return data;
    }

    // 拖拽结束
    onDragEnd = result => {
        let { tabActiveIndex, tabList } = this.state;
        tabList[tabActiveIndex].sortData = result;
        this.setState({ tabList: tabList });
    };

    // 左侧点击选中
    chooseColumn = ele => {
        let { tabActiveIndex, tabList } = this.state;
        let activeTabData = tabList[tabActiveIndex];
        let { displayData, sortData } = activeTabData;
        if (ele.showItem === true) {
            let newSortData = sortData.filter(val => val.attrcode !== ele.attrcode);
            let newDisplayData = displayData.map(val => {
                if (val.attrcode === ele.attrcode) {
                    //左侧隐藏
                    val.showItem = false;
                    val.visible = true;
                    newSortData.push(val);
                }
                return val;
            });
            activeTabData.displayData = newDisplayData;
            activeTabData.sortData = newSortData;
            this.setState({ tabList: tabList });
        }
    };

    // 右侧点击删除 不删除数据，改变数据的
    ToHideOneCol = ele => {
        let { tabActiveIndex, tabList } = this.state;
        let activeTabData = tabList[tabActiveIndex];
        let { displayData, sortData } = activeTabData;
        if (ele.noDeletion || ele.redstar) {return;}
        if (ele.visible === true) {
            let newSortData = sortData.filter(val => val.attrcode !== ele.attrcode);
            let temp = {};
            let newDisplayData = displayData.map(val => {
                if (val.attrcode === ele.attrcode) {
                    val.showItem = true;
                    val.highLight = false;
                    val.islock = false;
                    val.visible = false;
                    temp = { ...val };
                }
                return val;
            });
            temp.showItem = false;
            newSortData.push(temp);
            activeTabData.displayData = newDisplayData;
            activeTabData.sortData = newSortData;
            this.setState({ tabList: tabList });
        }
    };

    // 点击锁，锁定该列之前的列 锁定之后该列以及之前的列不参与排序
    ToLockCols = ele => {
        let { tabActiveIndex, tabList } = this.state;
        let activeTabData = tabList[tabActiveIndex];
        let { displayData, sortData } = activeTabData;
        if (ele.showItem === true) {
            // 先判断下能不能放这么多固定列
            let checkData = sortData.concat(ele);
            let flag = this.checkLockData(ele, checkData);
            if (flag) {
                // 左侧点击冻结，移动到右侧，并且冻结
                let newSortData = sortData.map(val => {
                    val.islock = true;
                    val.isLastLockCol = false;
                    return val;
                });
                let newDisplayData = displayData.map(val => {
                    if (val.attrcode === ele.attrcode) {
                        //左侧隐藏
                        val.showItem = false;
                        // 右侧锁定，并且设置为最后一个锁定列
                        val.islock = true;
                        val.isLastLockCol = true;
                        val.visible = true;
                        newSortData.push(val);
                    }
                    return val;
                });
                activeTabData.displayData = newDisplayData;
                activeTabData.sortData = newSortData;
                this.setState({ tabList: tabList });
            }
        } else {
            // 先判断下能不能放这么多固定列
            let flag = this.checkLockData(ele, sortData);
            if (flag) {
                // 右侧点击冻结
                for (let i = 0, len = sortData.length; i < len; i++) {
                    sortData[i].islock = true;
                    sortData[i].isLastLockCol = false;
                    if (ele.attrcode == sortData[i].attrcode) {
                        sortData[i].isLastLockCol = true;
                        break;
                    }
                }
                activeTabData.sortData = sortData;
                this.setState({ tabList: tabList });
            }
        }
    };

    // 解锁，解锁之前的所有列
    ToUnLockCols = ele => {
        let { tabActiveIndex, tabList } = this.state;
        let activeTabData = tabList[tabActiveIndex];
        let { sortData } = activeTabData;
        if (ele.islock === true) {
            for (let i = 0, len = sortData.length; i < len; i++) {
                sortData[i].islock = false;
                if (ele.attrcode == sortData[i].attrcode) {
                    sortData[i].isLastLockCol = false;
                    break;
                }
            }
            activeTabData.sortData = sortData;
            this.setState({ tabList: tabList });
        }
    };

    // 判断是否可以锁定 锁定列的总长度小于当前 u-table-scroll 下的div的总长度 表示可以锁定
    checkLockData(ele, sortData) {
        let { tableScope } = this.props;
        let { json = {} } = this.state;
        let tableBody = tableScope.table;
        let uTableBodyWidth = tableBody.querySelector(`.base-table-body-scroll-wrapper`);
        let tableBodyWidth = uTableBodyWidth && uTableBodyWidth.offsetWidth;
        // 第一列到点击的列的总宽度
        let lockColTotalWidth = 0;
        for (let i = 0, len = sortData.length; i < len; i++) {
            if (ele.attrcode == sortData[i].attrcode) {
                break;
            }
            let width = sortData[i].width ? parseFloat(sortData[i].width) : 0;
            lockColTotalWidth += width;
        }
        if (tableBodyWidth < lockColTotalWidth) {
            toast({
                duration: 'infinity',
                color: 'warning',
                content: json['table_colseting_tip14'],
                mark: 'lock-tip',
            });
            return false;
        }
        return true;
    }

    // 点击高亮显示
    ToHighLightCols = ele => {
        let { tabActiveIndex, tabList } = this.state;
        let activeTabData = tabList[tabActiveIndex];
        let { displayData, sortData } = activeTabData;
        if (ele.showItem === true) {
            // 左侧点击高亮，移动到右侧，并且高亮
            let newSortData = sortData.filter(val => val.attrcode !== ele.attrcode);
            let newDisplayData = displayData.map(val => {
                if (val.attrcode === ele.attrcode) {
                    //左侧隐藏
                    val.showItem = false;
                    //右侧显示
                    val.highLight = true;
                    newSortData.push(val);
                }
                return val;
            });
            activeTabData.displayData = newDisplayData;
            activeTabData.sortData = newSortData;
            this.setState({ tabList: tabList });
        } else {
            // 右侧点击高亮
            let newSortData = sortData.map(val => {
                if (val.attrcode === ele.attrcode) {
                    val.highLight = true;
                }
                return val;
            });
            activeTabData.sortData = newSortData;
            this.setState({ tabList: tabList });
        }
    };

    // 取消高亮
    ToUnHighLightCols = ele => {
        let { tabActiveIndex, tabList } = this.state;
        let activeTabData = tabList[tabActiveIndex];
        let { sortData } = activeTabData;
        if (ele.highLight === true) {
            sortData = sortData.map(val => {
                if (val.highLight === true) {
                    val.highLight = false;
                }
                return val;
            });
            activeTabData.sortData = sortData;
            this.setState({ tabList: tabList });
            this.setState({ sortData });
        }
    };

    // 设置列宽
    ToSetWidth = ele => {
        console.log(ele);
    }

    // 点击确定
    beSureClick = () => {
        let { beSureClick, tableScope, tableHeight } = this.props;
        let oldIsEllipsis = !tableScope?.state?.isEllipsis;
        let oldTableHeight = tableScope?.state?.tableHeight;
        console.log(oldIsEllipsis);
        let { tabList, sortData, displayData, isEllipsis, saveWidthFlag, resetWidthFlag, tableHeight: newTableHeight, showSubTotalFlag } = this.state;
        console.log( isEllipsis, saveWidthFlag, resetWidthFlag, tableHeight, showSubTotalFlag);
        let params = {
            displayData,
            sortData,
            ellipsisChange: oldIsEllipsis == isEllipsis,
            saveWidthFlag,
            resetWidthFlag,
            tableHeightChange: oldTableHeight != newTableHeight,
            tableHeight: newTableHeight,
            showSubTotalFlag,
        };
        beSureClick && beSureClick(tabList);
    }

    // 点击重置字段或取消
    resetClick = () => {
        let { resetClick } = this.props;
        resetClick && resetClick();
    }

    // 点击取消
    onColCancel = () => {
        let { onColCancel } = this.props;
        onColCancel && onColCancel();
    }

    // 自动折行
    ellipsisChange = flag => {
        let { tabActiveIndex, tabList } = this.state;
        let activeTabData = tabList[tabActiveIndex];
        activeTabData.isEllipsis = flag;
        this.setState({ tabList: tabList });
    }

    // 保存列宽
    saveWidthHandler = flag => {
        let { tabActiveIndex, tabList } = this.state;
        let activeTabData = tabList[tabActiveIndex];
        activeTabData.saveWidthFlag = flag;
        this.setState({ tabList: tabList });
    }

    // 重置列宽
    resetWidthHandler = flag => {
        let { tabActiveIndex, tabList } = this.state;
        let activeTabData = tabList[tabActiveIndex];
        activeTabData.resetWidthFlag = flag;
        this.setState({ tabList: tabList });
    }

    // 设置表格高度
    setTableHeightHandler = height => {
        let { tabActiveIndex, tabList } = this.state;
        let activeTabData = tabList[tabActiveIndex];
        activeTabData.tableHeight = height;
        this.setState({ tabList: tabList });
    }

    // 显示小计
    showSubTotalHandler = flag => {
        let { tabActiveIndex, tabList } = this.state;
        let activeTabData = tabList[tabActiveIndex];
        activeTabData.showSubTotalFlag = flag;
        this.setState({ tabList: tabList });
    }

    //侧拉的头部结构
    DrawerHeader = () => {
        let { json = {} } = this.state;
        const tip = (
            <div>
                <p>{json['table_colseting_tip05']}：</p>
                <p>1. {json['table_colseting_tip06'] + `"${json['table_colseting_waitadd']}"` + json['table_colseting_tip07'] + json['table_colseting_tip08']}
                    <i className='iconfont icon-shanchu4' />，{json['table_colseting_tip09']}；
                </p>
                <p>2. {json['table_colseting_tip10'] + `"${json['table_colseting_readyadd']}"` + json['table_colseting_tip07'] + json['table_colseting_tip11']}
                    <i className='iconfont icon-tuozhuai' />，{json['table_colseting_tip12']}；
                </p>
                <p>3. {json['table_colseting_tip06']}<i className='iconfont icon-weisuoding' />{json['table_colseting_tip13']}。</p>
            </div>
        );

        return (
            <div className="settingSideBox-header">
                <div className="title">
                    {json['table_colseting_table']} {/*列表设置*/}
                    <Tooltip
                        placement="right"
                        className='col-setting-tips'
                        overlay={tip}
                    >
                        <i className='iconfont icon-bangzhutishi' />
                    </Tooltip >
                </div>
                <div className="headerBtn">
                    <HotKeys
                        keyMap={{
                            sureBtnHandler:
                                HotKeys.USUAL_KEYS.MODAL_CONFIRM,
                            cancelBtnHandler:
                                HotKeys.USUAL_KEYS.MODAL_CANCEL,
                        }}
                        handlers={{
                            sureBtnHandler: () => {
                                // 确定按钮的事件 
                                console.log('sureBtnHandler 事件回调');
                                this.beSureClick();
                            },
                            cancelBtnHandler: () => {
                                // 重置字段按钮的事件 
                                console.log('cancelBtnHandler 事件回调');
                                this.onColCancel();
                            },
                        }}
                        className="settingSideBox-hotkeys-wrapper"
                        focused={true}
                        attach={document.body}
                        display="inline"
                    />
                    <Tooltip
                        placement="top"
                        inverse
                        overlay={`${json["table_colseting_ok"]}  (${HotKeys.USUAL_KEYS.MODAL_CONFIRM})`}
                        trigger={['hover', 'focus']}
                    >
                        <Button
                            onClick={this.beSureClick}
                            colors="primary"
                            tabIndex="0"
                            fieldid="confirm"
                            className="settingSideBox-sure"
                        >
                            {json["table_colseting_ok"]}(<span className="text-decoration-underline">Y</span>)
                        </Button>
                    </Tooltip>
                    <Button className="settingSideBox-reset" onClick={this.resetClick}>
                        {json['table_col_setting_reset']} {/*重置字段*/}
                    </Button>
                    <Tooltip
                        placement="top"
                        inverse
                        overlay={`${json["table_colseting_ok"]}  (${HotKeys.USUAL_KEYS.MODAL_CANCEL})`}
                        trigger={['hover', 'focus']}
                    >
                        <Button
                            onClick={this.onColCancel}
                            colors="primary"
                            tabIndex="0"
                            fieldid="confirm"
                            className="settingSideBox-cancel"
                        >
                            {json["table_colseting_cancel"]}(<span className="text-decoration-underline">Y</span>)
                        </Button>
                    </Tooltip>
                </div>
            </div>
        );
    };

    onChangeFun(item) {
        this.setState({ tabActiveIndex: item.index });
    }

    render() {
        let { toCloseDrawer } = this.props;
        const { tabActiveIndex, json = {}, tabList = [] } = this.state;
        let tabsControlList = tabList.map(item => <div key={item.key} clickFun={this.onChangeFun.bind(this, item)}>{item.title}</div>);
        let valueProps = {
            chooseColumn: this.chooseColumn,
            ToHideOneCol: this.ToHideOneCol,
            ToLockCols: this.ToLockCols,
            ToUnLockCols: this.ToUnLockCols,
            ToHighLightCols: this.ToHighLightCols,
            ToUnHighLightCols: this.ToUnHighLightCols,
            ToSetWidth: this.ToSetWidth,
            json,
        };
        let activeTabData = tabList[tabActiveIndex];
        let { displayData, sortData, isEllipsis, saveWidthFlag, resetWidthFlag, tableHeight, showSubTotalFlag } = activeTabData;
        return (
            <SettingSideBoxContext.Provider value={valueProps}>
                <Fragment>
                    <SideBox
                        title={this.DrawerHeader()}
                        mask={true}
                        show={true}
                        maskClose={toCloseDrawer}
                        width={1200}
                        onClose={toCloseDrawer}
                        className="settingSideBox"
                    >
                        <div className="settingSideBoxContent">
                            <TabsControl
                                defaultKey={tabActiveIndex}
                            >
                                {tabsControlList}
                            </TabsControl>
                            {
                                // displayData sortData 存在表示为字段设置 否则为其他设置
                                displayData ?
                                    <SettingSideBoxContent
                                        {...this.props}
                                        leftData={displayData}
                                        rightData={sortData}
                                        json={json}
                                    >
                                    </SettingSideBoxContent>
                                    :
                                    <OtherSettings
                                        {...this.props}
                                        ellipsisChange={this.ellipsisChange}
                                        saveWidthHandler={this.saveWidthHandler}
                                        resetWidthHandler={this.resetWidthHandler}
                                        setTableHeightHandler={this.setTableHeightHandler}
                                        showSubTotalHandler={this.showSubTotalHandler}
                                        isEllipsis={isEllipsis}
                                        saveWidthFlag={saveWidthFlag}
                                        resetWidthFlag={resetWidthFlag}
                                        tableHeight={tableHeight}
                                        showSubTotalFlag={showSubTotalFlag}
                                        json={json}
                                    >
                                    </OtherSettings>
                            }

                        </div>
                    </SideBox>
                </Fragment>
            </SettingSideBoxContext.Provider>
        );
    }
}
